// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3Z9KP","imageUploader":"EGiftCard_imageUploader__3R65o"};